import Parse from 'parse';

const login = (params) => {
	const { username, password, sessionToken } = params;
	if (sessionToken) {
		return Parse.User.become(sessionToken)
			.then(() => {});
	}
	return Parse.User.logIn(username, password)
		.then(() => {});
};

const logout = () => {
	return Parse.User.logOut()
		.then(() => {});
};

const checkError = (error = {}) => {
	if (error.code === Parse.Error.INVALID_SESSION_TOKEN) {
		return Promise.reject();
	}
	return Promise.resolve();
};

const checkAuth = () => {
	if (Parse.User.current()) {
		return Promise.resolve();
	}
	return Promise.reject();
};

const getIdentity = () => { return Promise.resolve({ id: Parse.User.current().id }); };

const provider = ({ URL, APP_ID, JAVASCRIPT_KEY }) => {
	if (Parse.applicationId === null || Parse.javaScriptKey === null) {
		Parse.initialize(APP_ID, JAVASCRIPT_KEY);
		Parse.serverURL = URL;
	}
	return {
		checkAuth,
		checkError,
		getIdentity,
		login,
		logout,
	};
};

export default provider;
